import ReactUtils from '../../packages/react-utils/react-utils.js';
import 'react';

var iconValidator = function () {
  return function (_a) {
    var iconLeft = _a.iconLeft,
      iconRight = _a.iconRight;
    if (iconLeft && !ReactUtils.isOfType(iconLeft, 'Icon') && !ReactUtils.isOfType(iconLeft, 'Button')) {
      return new Error("Input component only accepts \"Icon\" or \"Button\" component as iconLeft, but received ".concat(ReactUtils.getElementName(iconLeft), "."));
    }
    if (iconRight && !ReactUtils.isOfType(iconRight, 'Icon') && !ReactUtils.isOfType(iconRight, 'Button')) {
      return new Error("Input component only accepts \"Icon\" or \"Button\" component as iconRight, but received ".concat(ReactUtils.getElementName(iconRight), "."));
    }
    return null;
  };
};

export { iconValidator };
